// This File is to allow for support with the new TL syntax, please keep this up to date as keys.txt changes,
// or if we want to update the text on a string
// we have a tool will that builds a legacyi18nObject using this mapping
// the tool is buildLegacyI18n in @bingads-webui-campaign/smart-i18n
// this file isn't exported, because we don't want the _TL_ syntax visible in the main exported code,
// as it breaks if not running through the bundler
export const legacyStrings = {
  SignUpAgreementLinkText: _TL_('Microsoft Advertising Terms and Conditions'),
  NewUserConsentToAgreement: _TL_(
    'I agree to the {0}.',
    {
      comment: 'Consent on signup and activate MSA user page for user consent to "agreement and terms". {0} is the anchor link for agreement and terms. See the string SignUpAgreementLinkText',
    }
  ),
  SignUp_Agreements_World: _TL_(
    'Send me marketing information about Bing, search advertising, search tips, and webinars from Microsoft Advertising. (You can always unsubscribe.)',
    {
      comment: 'Note that this string also is Line 1 of the Germany agreement text.',
    }
  ),
  SignUp_Agreements_Germany_Line2: _TL_('Microsoft can contact me via email or telephone about products, events, benefits, services, and customer surveys.'),
  SignUp_Agreements_Germany_Line3: _TL_(
    'By using Microsoft Advertising, I acknowledge that my data is being collected and used by Microsoft Ireland Operations Limited in Ireland, Microsoft Corporation in the USA, and other Microsoft subsidiaries worldwide ({0}).',
    {
      comment: '{0} is a link to the Microsoft worldwide website, e.g. "www.microsoft.com/worldwide".',
    }
  ),
  SignUp_Agreements_Germany_Line4: _TL_(
    'The agreement can be retracted at any time via {0}.',
    {
      comment: '{0} is an email address, e.g. "kunden@microsoft.com".',
    }
  ),
  SignUp_Agreements_For_Notice_Country: _TL_(
    'Microsoft may use your contact information to send tips and offers about Microsoft Advertising and other products. See the {0} and unsubscribe anytime.',
    {
      comment: '{0} is a link to Privacy Statement, which points to "https://go.microsoft.com/fwlink/?LinkId=521839".',
    }
  ),
  SignUpAgreementPrivacyStatementText: _TL_('Privacy Statement'),
};
